/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useCallback, useRef, useEffect } from 'react';

const useAbortController = () => {
  const controllerRef = useRef<AbortController>(new AbortController());

  useEffect(() => {
    if (controllerRef.current) controllerRef.current.abort();

    controllerRef.current = new AbortController();

    return () => controllerRef.current.abort();
  }, []);

  const get = useCallback(() => controllerRef.current, []);

  const set = useCallback((newAbortController: AbortController) => {
    controllerRef.current = newAbortController;
    return controllerRef.current;
  }, []);

  const reset = useCallback(() => {
    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    return controllerRef.current;
  }, []);

  const abort = useCallback(() => {
    controllerRef.current.abort();
    return controllerRef.current;
  }, []);

  return { get, set, reset, abort };
};

export default useAbortController;
